export const CACHE_PREFIX = 'gfx_'
